/**
 * External dependencies
 */
import { render } from 'react-dom'
import VisibilitySensor from 'react-visibility-sensor'
import BlockErrorBoundary from '~bookwormgb/components/block-error-boundary'

/**
 * Renders a block component in the place of a specified set of selectors.
 *
 * @param {string}   selector   CSS selector to match the elements to replace.
 * @param {Function} Block      React block to use as a replacement.
 * @param {Function} [getProps] Function to generate the props object for the
 * block.
 */
export default ( selector, Block, getProps = () => {} ) => {
	document.addEventListener( "DOMContentLoaded", () => {
		const containers = document.querySelectorAll( selector )

		if ( containers.length ) {
			// Use Array.forEach for IE11 compatibility.
			Array.prototype.forEach.call( containers, ( el, i ) => {
				const props = getProps( el, i )
				const attributes = {
					...el.dataset,
					...props.attributes,
				}

				el.classList.remove( 'is-loading' )

				render(
					<BlockErrorBoundary>
						{ props.hasVisibilitySensor ? (
							<VisibilitySensor partialVisibility={ true }>
								{ ( { isVisible } ) => {
									return <Block { ...props } attributes={ attributes } hasVisibilitySensor={ true } isVisible={ isVisible } />
								} }
							</VisibilitySensor>
						) : (
							<Block { ...props } attributes={ attributes } />
						) }
					</BlockErrorBoundary>,
					el
				)
			} )
		}
	} )
}
